const destinations = [
  {
    name: '大理洱海',
    description: '苍山雪，洱海月，风花雪月的浪漫',
    image: 'https://readdy.ai/api/search-image?query=Dali%20Erhai%20Lake%20with%20traditional%20white%20houses%20and%20Cangshan%20mountains%2C%20golden%20sunset%20light%2C%20wooden%20boats%20on%20calm%20water%2C%20romantic%20Yunnan%20landscape&width=800&height=500&seq=dest-dali&orientation=landscape',
    count: 86,
  },
  {
    name: '巴厘岛',
    description: '众神之岛的热带蜜月天堂',
    image: 'https://readdy.ai/api/search-image?query=Bali%20tropical%20paradise%20with%20ancient%20temple%20at%20sunset%2C%20lush%20green%20rice%20terraces%2C%20palm%20trees%2C%20romantic%20honeymoon%20destination%2C%20warm%20golden%20light&width=800&height=500&seq=dest-bali&orientation=landscape',
    count: 124,
  },
  {
    name: '京都',
    description: '千年古都的红叶与樱花之恋',
    image: 'https://readdy.ai/api/search-image?query=Kyoto%20Japan%20traditional%20wooden%20temple%20with%20autumn%20maple%20leaves%2C%20stone%20garden%2C%20kimono%20couple%2C%20romantic%20ancient%20capital%2C%20soft%20morning%20light&width=800&height=500&seq=dest-kyoto&orientation=landscape',
    count: 67,
  },
  {
    name: '清迈',
    description: '泰北小城的文艺慢时光',
    image: 'https://readdy.ai/api/search-image?query=Chiang%20Mai%20Thailand%20old%20city%20temple%20with%20golden%20stupa%2C%20lush%20green%20mountains%2C%20peaceful%20atmosphere%2C%20traditional%20Lanna%20style%2C%20warm%20sunset&width=800&height=500&seq=dest-chiangmai&orientation=landscape',
    count: 43,
  },
];

export default function Destinations() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900">
            热门目的地
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            全球360+浪漫目的地，总有一个适合你们的下一站
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {destinations.map((dest) => (
            <article key={dest.name} className="group cursor-pointer">
              <div className="relative h-40 md:h-52 rounded-lg overflow-hidden mb-3">
                <img
                  src={dest.image}
                  alt={dest.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-white text-xs">
                    <strong className="text-sm font-heading">{dest.count}</strong> 篇攻略
                  </span>
                </div>
              </div>
              <h4 className="font-heading font-semibold text-foreground-900 text-sm md:text-base group-hover:text-primary-500 transition-colors">
                {dest.name}
              </h4>
              <p className="text-foreground-400 text-xs mt-1">{dest.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}